export default {
  filterCommonLoading: "लोड हो रहा है...",
  filterCommonNoData: "कोई डेटा नहीं",

  hiringLocation: "हायरिंग स्थान",
  dateRange: "दिनांक सीमा",
  marketGalleries: "गैलरी",
  marketGalleriesPlaceholder: "गैलरी दर्ज करें",
  marketCategories: "श्रेणियाँ",
  marketCategoriesPlaceholder: "श्रेणियाँ दर्ज करें",
  newsLocations: "समाचार स्थान",
  publishedDateRange: "प्रकाशित दिनांक सीमा",
  industryCategories: "उद्योग श्रेणियाँ",
  industryCategoriesPlaceholder: "उद्योग श्रेणियाँ दर्ज करें",
  industrySubCategories: "उप-उद्योग श्रेणियाँ",
  sequencePlaceholder: "अनुक्रम का नाम दर्ज करें",
  pageviewGreaterThan: "पेजव्यू",
  sessionGreaterThan: "सत्र",
  advertisements: "विज्ञापन",
  accountLocation: "खाता स्थान",
  startDate: "आरंभ तिथि",
  endDate: "अंतिम तिथि",
  inputNumberMin: "न्यूनतम",
  inputNumberMax: "अधिकतम",
  postingLocation: "पोस्टिंग स्थान",

  filterJob: "नौकरी खोज",
  filterJobPostingDateSubTitle: "पोस्टिंग की अवधि",
  filterJobPostingLocation: "पोस्टिंग स्थान",
  filterJobTitlesSubTitle: "नौकरी के शीर्षक",

  filterNews: "समाचार",
  filterNewsPublishedDateSubTitle: "प्रकाशित होने की अवधि",
  filterNewsCategories: "श्रेणियाँ",

  filterEmployeeCustomRange: "कस्टम सीमा",

  filterAdvancedSearch: "उन्नत खोज",
  allSearchResultsFor: '"{count}" के लिए सभी खोज परिणाम',
  filterAdvancedSearchTooltip:
    "केवल सटीक शब्दों से ही नहीं, बल्कि अर्थ से भी परिणाम ढूंढता है।",

  filterSpecialties: "विशेषज्ञता",
  filterSpecialtiesPlaceHolder: "विशेषज्ञता दर्ज करें",

  filterIndustrySubCategories: "उप-उद्योग",
  filterIndustrySubCategoriesPlaceHolder: "उप-उद्योग दर्ज करें",

  filterAdPlaceholder: "विज्ञापन दर्ज करें",

  filterEmployeesPlaceholder: "कर्मचारियों का चयन करें",

  filterLocationExcludeText: "चयनित स्थानों को बाहर करें",
  filterLocationExcludeTooltip:
    "सक्षम होने पर, ये स्थान आपके परिणामों से फ़िल्टर कर दिए जाएंगे।",
  filterManagementPlaceholder: "प्रबंधन स्तर दर्ज करें",

  filterJobFunctionPlaceholder: "नौकरी के कार्य दर्ज करें",

  filterDepartmentPlaceholder: "विभाग दर्ज करें",

  filterPage: "पेज",
  filterPerPage: "एक ही पेज में आइटम की संख्या",

  filterCompanyPlaceHolder: "कंपनियां दर्ज करें",
  filterCompanyCSVImport:
    "आपके पास पहले से मौजूद कंपनियों की सूची आसानी से आयात करें",
  filterCompanyCSVText: "कंपनी सूची आयात करें (CSV)",

  csvComponentTitle1: "CSV अपलोड करें",
  csvComponentTitle2: "अपलोड की समीक्षा करें",
  csvTipNeedHelp: "मदद चाहिए?",
  detectFileNumber: "{count} कंपनियां मिलीं",
  uploadLoading: "अपलोड हो रहा है...",
  uploadReplace: "बदलें",
  noCompaniesWereDetectedInYourFile:
    "आपकी फ़ाइल में कोई भी कंपनी नहीं मिली। कृपया अपना डेटा जांचें और फिर से अपलोड करें।",
  fileContainsManyCompanies:
    "आपकी फ़ाइल में कई कंपनियां हैं, केवल पहली {count} का उपयोग किया जाएगा।",
  onlyReturnOneResultPerCompany: "प्रति कंपनी केवल 1 परिणाम दिखाएं",
  btnViewCompanyList: "कंपनी सूची देखें",
  csvFileAnalysisFailed:
    "CSV फ़ाइल विश्लेषण विफल रहा, कृपया बाद में पुनः प्रयास करें",
  downloadFailed: "डाउनलोड विफल रहा। कृपया पुनः प्रयास करें।",
  downloadSampleCsv: "नमूना CSV डाउनलोड करें",
  firstHundredEntriesWillBeProcessed:
    "प्रति फ़ाइल केवल पहले {count} प्रविष्टियों को संसाधित किया जाएगा।",
  detectingCompaniesInFile: "आपकी फ़ाइल में कंपनियों का पता लगाया जा रहा है...",
  thisMayTakeAFewSeconds: "इसमें कुछ सेकंड लग सकते हैं।",

  filterSaveText: "खोज सहेजें",
  filterClearAllText: "सभी साफ़ करें",

  filterRemoved: "फ़िल्टर हटा दिया गया",
};
